import { render, staticRenderFns } from "./table-card.vue?vue&type=template&id=36f59eb4&scoped=true"
import script from "./table-card.vue?vue&type=script&lang=js"
export * from "./table-card.vue?vue&type=script&lang=js"
import style0 from "./table-card.vue?vue&type=style&index=0&id=36f59eb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f59eb4",
  null
  
)

export default component.exports